
import XHeader from 'vux/src/components/x-header/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import XTable from 'vux/src/components/x-table/index.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'

import api from "~api";
export default {
name: "search-course",
components: {
XHeader,Selector,XTable, Swiper, SwiperItem
},
created(){
var _this = this;
_this.$vux.loading.show({
text: ''
})
api.post('/stuTable',{"stuNumber": _this.$store.state.stu_num})
.then(function (response) {
var data = response.data;
console.log(data);
if (data.code == "0"){
var totalweek = parseInt(data.totalWeek);
_this.currentterm = data.yearTerm;
_this.currentweek = data.currentWeek;
for(var i = 0;i<totalweek;i++) {
var tmp = {
key: i,
value: "第"+(i + 1)+"周"
};
_this.termlist.push(tmp);
}
var course = data.data;
_this.colspan = _this.getcolspan(course);
_this.current =  data.currentWeek-1;
_this.$vux.loading.hide()
}else {
_this.$msgbox('温馨提示',"查询失败");
}
_this.$vux.loading.hide()
})
},
data(){
return{
currentterm:'',
currentweek:3,
current:'',
index:0,
weekcourse:[{name:'11'},{name:'11'},{name:'11'}],
hasData: true,
termlist:[],
yourcourse:[],
colspan:null,
colorArr:['#3aa7eb','#50ba45','#b0e453','#f79b63','#8a5ae8','#f5517c']
}
},
methods:{
onChange (val) {
this.current = val;
this.getCourse();
},
goHome(){
var _this= this;
_this.$router.push({name: 'home'});

},
getCourse () {
var _this = this;
_this.$vux.loading.show({
text: 'Loading'
})
_this.yourcourse = [];
api.post('/stuTable',{"stuNumber": _this.$store.state.stu_num,"currentweek": _this.current+1})
.then(function (response) {
var data = response.data;
if (data.code == "0"){
_this.yourcourse = _this.courseObjtoArr(data.data);
_this.$vux.loading.hide()
}else{
_this.$msgbox('温馨提示',"请联系管理员");
}
_this.$vux.loading.hide()
})
.catch(function (error) {
_this.$msgbox('温馨提示','系统内部异常，请联系管理员！');
_this.$vux.loading.hide()
})
},
courseObjtoArr(obj){
var arr = Object.getOwnPropertyNames(obj); 
var arr2 = Object.keys(obj);
var valArr = arr.map(function(i){return obj[i]});
return valArr;
},
getcolspan(course){
var arr = []
for (let i in course) {
let o = {};
o[i] = course[i];
arr.push(o);
}
var rowspan = new Array();
for(var i = 0;i<7;i++){
rowspan[i] = new Array();
for(var j =i;j<9;j=j+2){
var k = j+1;
if(arr[j][i]!= undefined && arr[j][i]==arr[k][i]){
rowspan[i][j] = 2;
}
}
}

return  rowspan;
}
}
}



// WEBPACK FOOTER //
// ./src/components/SearchCourse.vue